define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/xml",
	"csi/action/FormData",
	"csi/table/NewFrom",
	"csi/wizard/ActionControllerMixin"
], function(array,declare,lang,xml,FormData,NewFrom,ActionControllerMixin) {

	var SELECT_PRODUCT_PAGE = 0;
	var SELECT_COLORS_PAGE = 1;

	return declare([NewFrom, ActionControllerMixin], {
		_fdColors: null,

		// prevent theme master from auto-populating
		bUseNodeForForm: false,

		/**
		 * Only one selection is allowed
		 * @param {FormData} fd
		 */
		onFormData: function(fd) {
			fd.m_bSelectOne = true;
		},

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set default value for theme
			this.inherited(arguments);
			
			if (view.addDefaultValue) {
				view.addDefaultValue("Node Name", this.getNode().$Name);
			}
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard, /*Content*/currentPage, /*Content*/nextPage, /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			var	nPage = wizard.getIndexOfPage(nextPage);
			var	dfd, fd;
			var	bRefresh = false;

			switch (nPage) {
				case SELECT_PRODUCT_PAGE:
					// use controller's form data to select product
					fd = this.m_formData;
					fd.m_bRequireOne = true;
					fd.m_fAggregateTest = lang.hitch(this, this._canSelectProduct);
					break;

				case SELECT_COLORS_PAGE:
					this.product = this.m_formData.getSelectedNode();

					// initialize form data if not already done - this page uses form data from this controller
					fd = this._fdColors = this._fdColors || new FormData(this);

					// if form data node has changed, then reset selections and refresh view
					if (fd.getNode() != this.product) {
						fd.resetSelections();
						fd.setNode(this.product);
						bRefresh = true;
					}

					break;
			}

			if (fd) {
				dfd = wizard.setFormDataToPage(nextPage, fd, bRefresh);
			}

			return dfd;
		},

		_canSelectProduct: function(/*Context*/ctx, /*FormData*/fd) {
			return true;
		},

		toWriterRequest: function() {
			// summary: add colors parameter
			var	call = this.inherited(arguments);
			call.addParameter("ColorURLs", xml.ATTR_REFLIST, this._fdColors.getSelectedValue());
			return call;
		},
		
		/**
		 * disable Finish & Go
		 */
		_canNavigate: function() {
			return false;
		},
	});
});